<template>
  <v-dialog @input="change" value="true" :max-width="width" :persistent="persistent" @keydown.esc="choose(false)">
        <v-toolbar v-bind:class="[center ? '' : '', color]" v-if="Boolean(title)" :color="color" dark dense>
            <v-icon v-if="Boolean(icon)">{{ icon }}</v-icon>
            <v-toolbar-title v-bind:class="{'text-white': color !== 'white'}" v-text="title"/>
        </v-toolbar>
        <v-card tile v-bind:class="{center: center}">
            <v-card-text v-html="message"/>      
                <slot></slot>      
            <v-card-actions>
                <v-spacer/>
                <div style="width: 100%; text-align: right;" v-bind:class="{center: center}">
                    <Btn v-if="Boolean(buttonFalseText)" :type="buttonFalseColor" flat @click="choose(false)">{{ buttonFalseText }}</Btn>
                    <Btn v-if="Boolean(buttonTrueText)" :type="buttonTrueColor" flat @click="choose(true)">{{ buttonTrueText }}</Btn>
                </div>
            </v-card-actions>
        </v-card>
  </v-dialog>
</template>

<script>
import Btn from './Btn'
import 'vuetify/src/stylus/app.styl'
import { VCard, VCardActions, VCardText, VDialog, VIcon, VToolbar, VToolbarTitle, VSpacer } from 'vuetify/lib'

export default {
  components: {
    VCard,
    VCardActions,
    VCardText,
    VDialog,
    VIcon,
    VToolbar,
    VToolbarTitle,
    VSpacer,
    Btn
  },
  props: {
    buttonTrueText: {
      type: String,
      default: 'Si'
    },
    buttonFalseText: {
      type: String,
      default: 'No'
    },
    buttonTrueColor: {
      type: String,
      default: 'green'
    },
    buttonFalseColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'warning'
    },
    icon: {
      type: String,
      default: 'warning'
    },
    message: {
      type: String,
      required: true
    },
    persistent: Boolean,
    center: Boolean,
    title: {
      type: String
    },
    width: {
      type: String,
      default: '15em'
    }
  },
  data () {
    return {
      value: false
    }
  },
  methods: {
    choose (value) {
      this.$emit('result', value)
      this.value = value
      this.$destroy()
    },

    change () {
      this.$destroy()
    }
  }
}
</script>
